// extracted by mini-css-extract-plugin
export default {"opening":"LandingPage_opening__Tv6MN","quote":"LandingPage_quote__xubyP"};